export default __webpack_public_path__ + "static/media/trustpilot.0e9ead38.svg";